import { render, staticRenderFns } from "./TableColumnCustom.vue?vue&type=template&id=3c764470&scoped=true"
import script from "./TableColumnCustom.vue?vue&type=script&lang=js"
export * from "./TableColumnCustom.vue?vue&type=script&lang=js"
import style0 from "./TableColumnCustom.vue?vue&type=style&index=0&id=3c764470&prod&lang=less&scoped=true"
import style1 from "./TableColumnCustom.vue?vue&type=style&index=1&id=3c764470&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c764470",
  null
  
)

export default component.exports